import React, { forwardRef, useState, Ref } from 'react';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

export type InputPasswordProps = TextFieldProps & {
  errorMessage?: string;
};

export const Password = (
  { errorMessage, ...props }: InputPasswordProps,
  ref: Ref<HTMLInputElement | HTMLDivElement>,
) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextField
      type={showPassword ? 'text' : 'password'}
      label={props.label}
      placeholder={props.placeholder}
      onChange={props.onChange}
      ref={ref}
      helperText={props.helperText}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => setShowPassword((show) => !show)}
              onMouseDown={(event) => event.preventDefault()}
              onMouseUp={(event) => event.preventDefault()}
              edge="end"
            >
              {showPassword ? (
                <VisibilityIcon sx={{ color: 'myGrey.grey400' }} />
              ) : (
                <VisibilityOffIcon sx={{ color: 'myGrey.grey400' }} />
              )}
            </IconButton>
          </InputAdornment>
        ),
        disableUnderline: true,
      }}
      sx={(theme) => ({
        width: '100%',
        '& .MuiInputBase-root': {
          borderRadius: '8px',
          minHeight: '44px',
          border: errorMessage?.length > 1 ? '1px solid' : 'none',
          borderColor: errorMessage?.length > 1 ? theme.palette.error.main : 'transparent',
          [theme.breakpoints.down('lg')]: {
            minHeight: 46,
            borderRadius: '6px',
          },
        },
      })}
    />
  );
};

export const InputPassword = forwardRef(Password);
